import { STORE_TIME_ZONE } from "./format";

const WEEKDAYS = {
  Monday: 0,
  Tuesday: 1,
  Wednesday: 2,
  Thursday: 3,
  Friday: 4,
  Saturday: 5,
  Sunday: 6,
};

function timeToMinutes(time) {
  const [hours, minutes] = time.split(":").map(Number);
  return hours * 60 + minutes;
}

function getStoreClock(date) {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: STORE_TIME_ZONE,
    weekday: "long",
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
  }).formatToParts(date);
  const values = Object.fromEntries(
    parts.map(({ type, value }) => [type, value])
  );

  return {
    weekday: WEEKDAYS[values.weekday],
    minutes: Number(values.hour) * 60 + Number(values.minute),
  };
}

function isWithinOpeningHour(openingHour, clock) {
  const start = timeToMinutes(openingHour.start);
  const end = timeToMinutes(openingHour.end);

  if (start < end) {
    return (
      openingHour.weekday === clock.weekday &&
      start <= clock.minutes &&
      clock.minutes < end
    );
  }

  if (start > end) {
    const previousWeekday = (clock.weekday + 6) % 7;
    return (
      (openingHour.weekday === clock.weekday && clock.minutes >= start) ||
      (openingHour.weekday === previousWeekday && clock.minutes < end)
    );
  }

  return false;
}

export function getOpeningStatus(openingHours, now = new Date()) {
  const clock = getStoreClock(now);
  const activeOpeningHour = openingHours.find((openingHour) =>
    isWithinOpeningHour(openingHour, clock)
  );
  const todayOpeningHours = openingHours.filter(
    ({ weekday }) => weekday === clock.weekday
  );

  return {
    isOpen: Boolean(activeOpeningHour),
    activeOpeningHour,
    todayOpeningHours,
  };
}
